export class TblCourses {
    refNo: number;
    courseName: string;
    lastDate: string;
    batch:string;
    active:string
}